import { getThemeColor, NavLink, Button } from '@mantine/core';
import { ForeColorYellow } from '../../lib/constants';

function NavbarLink({ label, link, onClick, isActive }) {
  const isContact = label === 'CONTACT US';

  if (isContact) {
    return (
       <Button
        component="a"
        href={link}
        onClick={onClick}
        radius="sm"
        size="md"
        mx={50}
        pt={7}
        style={{
          backgroundColor: ForeColorYellow,
          color: 'white',
          marginLeft: 10,
          fontSize:'16px'
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <NavLink
      href={link}
      label={label}
      active={isActive}
      mr={50}
      styles={{
        label: {
          color: 'black',
          textDecoration: isActive ? 'underline' : 'none',
          fontSize:"16px"
        },
        root: {
          width: 'unset',
        },
      }}
      onClick={onClick}
    />
  );
}

export default NavbarLink;
